// src/components/Avaliacao/AvaliacoesPendentes.jsx

import React, { useState, useEffect } from 'react';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Button,
  Alert,
  CircularProgress,
  Box,
  Chip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import avaliacaoService from '../../services/avaliacaoService';

const AvaliacoesPendentes = () => {
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAvaliacoes = async () => {
      try {
        setLoading(true);
        // Agora chama listarAvaliacoesPendentes() sem parâmetros
        const response = await avaliacaoService.listarAvaliacoesPendentes();
        setAvaliacoes(response.data);
        setError(null);
      } catch (err) {
        console.error('Erro ao carregar avaliações pendentes:', err);
        setError('Não foi possível carregar as avaliações pendentes.');
      } finally {
        setLoading(false);
      }
    };

    fetchAvaliacoes();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }

  if (avaliacoes.length === 0) {
    return (
      <Alert severity="info" sx={{ m: 2 }}>
        Não há avaliações pendentes.
      </Alert>
    );
  }

  return (
    <Grid container spacing={2}>
      {avaliacoes.map(avaliacao => (
        <Grid item xs={12} sm={6} md={4} key={avaliacao.defesa_id}>
          <Card
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <CardHeader
              title={`Defesa ID: ${avaliacao.defesa_id}`}
              subheader={`Data da Defesa: ${
                avaliacao.data_defesa
                  ? new Date(avaliacao.data_defesa).toLocaleDateString()
                  : 'N/D'
              }`}
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Local da Defesa:</strong> {avaliacao.local_defesa}
              </Typography>
              {avaliacao.titulo_proposta && (
                <Typography variant="body2" color="text.secondary">
                  <strong>Título da Proposta:</strong> {avaliacao.titulo_proposta}
                </Typography>
              )}
              <Box sx={{ mt: 2 }}>
                <Chip
                  label={avaliacao.status || 'Pendente de Avaliação'}
                  color="warning"
                  size="small"
                />
              </Box>
            </CardContent>
            <CardActions sx={{ p: 2, pt: 0 }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  // Ajuste conforme sua rota de avaliação
                  // Por ex: navigate(`/avaliacoes/nova?defesaId=${avaliacao.defesa_id}`);
                  navigate(`/avaliacoes/registrar?defesaId=${avaliacao.defesa_id}`);
                }}
              >
                Avaliar
              </Button>
            </CardActions>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AvaliacoesPendentes;
